import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { Analytics } from "@vercel/analytics/react";
import { ThemeProvider } from "@emotion/react";
import { createTheme } from "@mui/material";
import { Footer } from "./components/landing-page/footer.tsx";
import {
  init,
  ErrorBoundary,
} from '@sentry/react';
import { SpeedInsights } from "@vercel/speed-insights/react";
import { PostHogProvider } from 'posthog-js/react';

init({
  dsn: import.meta.env.VITE_SENTRY_DNS,
  tracesSampleRate: 0,
  tracePropagationTargets: ["localhost", /^https:\/\/api\.diamedic\.co\.uk/],
});

const theme = createTheme({});

createRoot(document.getElementById("root")!).render(
  <div className="flex flex-col min-h-screen w-full">
    <ThemeProvider theme={theme}>
      <StrictMode>
        <Analytics />
        <SpeedInsights />
        <ErrorBoundary fallback={<p>Something went wrong.</p>}>
          <PostHogProvider
            apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
            options={{
              api_host: "https://eu.i.posthog.com",
              debug: import.meta.env.MODE === "development",
            }}
          >
            <App />
          </PostHogProvider>
        </ErrorBoundary>
        <Footer />
      </StrictMode>
    </ThemeProvider>
  </div>
);
